<template>
  <div>
    <v-dialog v-model="confirmCardTransferDialog" width="400">
      <v-card>
        <div class="px-6 pt-4 pb-2">
          <h4 class="text-center">Подтверждение!!</h4>
        </div>
        <p class="mb-1 text-center">{{ cardTransferMessage }}</p>
        <v-card-text>
          <validation-observer v-slot="{handleSubmit}" ref="confirmCardFormObs">
            <form @submit.prevent="handleSubmit(cardTransfer)">
              <v-card-text>
                <custom-input-text
                    pattern="######"
                    rules="required"
                    vid="code"
                    v-model="transfer.code"
                    label="Код"
                ></custom-input-text>
                <time-interval ref="timeInterval" v-model="timeout"></time-interval>
                <v-btn v-if="timeout<= 0" class="mb-3" color="primary" width="100%" @click="confirmCardTransfer">снова
                  отправить
                </v-btn>
                <div class="d-flex mx-n2">
                  <div class="px-2 flex-grow-1">
                    <v-btn color="error" width="100%" @click="confirmCardTransferDialog = false">Назад</v-btn>
                  </div>
                  <div class="px-2 flex-grow-1">
                    <v-btn color="primary" width="100%" type="submit">Подвердить</v-btn>
                  </div>
                </div>
              </v-card-text>
            </form>
          </validation-observer>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog width="300" v-model="transferPaymentDialog">
      <v-card>
        <div class="px-6 py-4">
          <h4>Принять платеж</h4>
        </div>
        <v-card-text>
          <validation-observer v-slot="{handleSubmit}" ref="acceptTransferObs">
            <form @submit.prevent="handleSubmit(submitTransfer)">
              <custom-select
                  rules="required"
                  v-model="transfer.type"
                  :items="CREDIT_PAYMENT_TYPES"
                  label="Тип платежа"
                  item-value="value"
                  item-text="text"
              ></custom-select>
              <money-input
                  label="Сумма"
                  rules="required"
                  vid="amount"
                  v-model="transfer.amount"
              ></money-input>
              <custom-select
                  v-if="isPaymentTypeCard"
                  label="Карта"
                  item-text="pan"
                  :items="cards"
                  v-model="transfer.card_id"
                  rules="required"
              ></custom-select>
              <div class="d-flex mx-n2 justify-end">
                <div class="px-2 flex-grow-1">
                  <v-btn width="100%" color="error" @click="transferPaymentDialog = false">Закрыть</v-btn>
                </div>
                <div class="px-2 flex-grow-1">
                  <v-btn width="100%" color="primary" type="submit">Принять</v-btn>
                </div>
              </div>
            </form>
          </validation-observer>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cashTransferConfirmDialog" width="400">
      <v-card>
        <v-card-text class="pt-5">
          <v-sheet color="primary py-2 px-4 rounded" dark>
            <v-icon>fas fa-info-circle</v-icon>
            Хотите принять оплату на сумму {{ transfer.amount|money }} ?
          </v-sheet>
          <div class="d-flex pt-4 mx-n2 justify-end">
            <div class="px-2">
              <v-btn small color="error" @click="cashTransferConfirmDialog = false">Назад</v-btn>
            </div>
            <div class="px-2">
              <v-btn small color="primary" @click="cashTransfer">подтвердить</v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {removerSpace} from "@/utils/pureFunctions";
import {messages, PAYMENT_TYPES_INDEX_VALUE, CREDIT_PAYMENT_TYPES} from "@/utils/constants";
import MoneyInput from "@/plugins/vuetify/components/MoneyInput";
import TimeInterval from "@/components/sms/TimeInterval";


export default {
  name: 'transfer-credit',
  props: {
    allAmount: {},
    credit_id: {},
    user_id: {}
  },
  data() {
    return {
      timeout: 0,
      CREDIT_PAYMENT_TYPES,
      cards: [],
      confirmCardTransferDialog: false,
      cashTransferConfirmDialog: false,
      transferPaymentDialog: false,
      transfer: {
        type: null,
        amount: null,
        card_id: null
      },
      cardTransferMessage: null,
    }
  },
  methods: {
    async getUserCards() {
      if (!this.cards.length) {
        try {
          const {data: {data}} = await this.$http.get(`admin/users/info/${this.user_id}`)
          this.cards = data.user_cards
        } catch (e) {
          this.$setResponseError({error: e})
        }
      } else {
        return Promise.resolve()
      }

    },
    async confirmCardTransfer() {
      this.$showLoading()
      let formData = {...this.transfer}
      formData.amount = removerSpace(formData.amount)
      try {
        const {data: {data: {message}}} = await this.$http.post('admin/credit/check-user-card', formData)
        this.cardTransferMessage = message
        this.confirmCardTransferDialog = true
        this.$nextTick(() => {
          const {timeInterval} = this.$refs
          if (timeInterval) timeInterval.setTime()
        })
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs['acceptTransferObs']})
      } finally {
        this.$clearLoading()
      }
    },
    clearTransfer() {
      this.transfer = {
        type: null,
        amount: null,
        card_id: null
      }
    },
    async cashTransferConfirm() {
      this.cashTransferConfirmDialog = true
    },
    async cashTransfer() {
      this.$showLoading()
      let formData = {...this.transfer}
      formData.amount = removerSpace(formData.amount)
      try {
        await this.$http.post('admin/credit/transfer', formData)
        this.$emit('transfer')
        this.$setSuccess({text: messages.successTransfer(formData.amount)})
        this.clearTransfer()
        this.transferPaymentDialog = false
        this.cashTransferConfirmDialog = false
      } catch (e) {
        this.$setFormError({error: e, obs: this.$refs['acceptTransferObs']})
        this.cashTransferConfirmDialog = false
      } finally {
        this.$clearLoading()
      }
    },
    async cardTransfer() {
      this.$showLoading()
      try {
        let formData = {...this.transfer}
        formData.amount = removerSpace(formData.amount)
        await this.$http.post('admin/credit/transaction', formData)
        this.$setSuccess({text: messages.successTransfer(formData.amount)})
        this.confirmCardTransferDialog = false
        this.transferPaymentDialog = false
        this.$emit('transfer')
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs['confirmCardFormObs']})
      } finally {
        this.$clearLoading()
      }
    },

    async submitTransfer() {
      try {
        this.transfer.credit_id = this.credit_id
        this.transfer.all = this.allAmount
        if (this.transfer.type === PAYMENT_TYPES_INDEX_VALUE.cash.value) {
          await this.cashTransferConfirm()
        } else if (this.transfer.type === PAYMENT_TYPES_INDEX_VALUE.card.value) {
          await this.confirmCardTransfer()
        } else if (this.transfer.type === PAYMENT_TYPES_INDEX_VALUE.terminal.value) {
          await this.cashTransferConfirm()
        }
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs['acceptTransferObs']})
        this.$clearLoading()
      }
    },
    show() {
      this.getUserCards()
      this.transferPaymentDialog = true
    }
  },
  computed: {
    isPaymentTypeCard() {
      return this.transfer.type === PAYMENT_TYPES_INDEX_VALUE.card.value
    }
  },
  components: {
    TimeInterval,
    MoneyInput
  },
  watch: {
    confirmCardTransferDialog(val) {
      if (!val) {
        const {confirmCardFormObs} = this.$refs
        if (confirmCardFormObs) confirmCardFormObs.reset()
      }
    },
    transferPaymentDialog(val) {
      if (!val) {
        const {acceptTransferObs} = this.$refs
        this.transfer = {
          amount: null,
          type: null
        }
        if (acceptTransferObs) acceptTransferObs.reset()
      }
    }
  }
}
</script>
